import {
  queryBusinessHomePageApi,
  queryUserPurchaseHistoryApi,
  queryActivityMessageApi,
  getBrandNoticeApi,
  saveOrUpdateBrandNoticeApi,
  queryGxHomePageApi
} from '@/api'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  商家首页信息
  async queryBusinessHomePageAction(context, param) {
    const res = await queryBusinessHomePageApi(param)
    return res
  },
  //  查询用户的消费记录
  async queryUserPurchaseHistoryAction(context, param) {
    const res = await queryUserPurchaseHistoryApi(param)
    return res
  },
  //  查询活动信息
  async queryActivityMessageAction(context, param) {
    const res = await queryActivityMessageApi(param)
    return res
  },
  //  获取品牌公告
  async getBrandNoticeAction(context, param) {
    const res = await getBrandNoticeApi(param)
    return res
  },
  //  新增/更新品牌公告
  async saveOrUpdateBrandNoticeAction(context, param) {
    const res = await saveOrUpdateBrandNoticeApi(param)
    return res
  },
  //  查询高校外卖模式后台首页
  async queryGxHomePageAction(context, param) {
    const res = await queryGxHomePageApi(param)
    return res
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
